import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { Heart, Eye, CheckCircle2, Sparkles } from "lucide-react";
import { formatPrice, resolveImg } from "../lib/api";
import { useStore } from "../context/StoreContext";

export default function FeaturedCard({ product, testid }) {
  const { toggleWishlist, inWishlist } = useStore();
  const img = resolveImg(product.images?.[0]) || "https://images.pexels.com/photos/1563016/pexels-photo-1563016.jpeg?auto=compress&cs=tinysrgb&w=800";
  const liked = inWishlist(product.id);

  // deterministic "viewers" counter per product (feels live, not random on each render)
  const viewers = useMemo(() => {
    const seed = (product.id || "").split("").reduce((a, c) => a + c.charCodeAt(0), 0);
    return 2 + (seed % 5); // 2..6
  }, [product.id]);

  const isMasterpiece = product.category === "шедьоври";

  return (
    <div className="product-card group bg-white border border-stone flex flex-col" data-testid={testid || `featured-card-${product.id}`}>
      <Link to={`/kartina/${product.slug || product.id}`} className="block relative overflow-hidden aspect-[4/5] bg-stone">
        <img src={img} alt={product.title} loading="lazy" className="product-img w-full h-full object-cover" />
        <span className="absolute top-3 left-3 flex items-center gap-1.5 bg-navy/90 text-white text-[10px] px-2.5 py-1 backdrop-blur-sm" data-testid={`viewers-${product.id}`}>
          <Eye size={12} className="text-gold" /> {viewers} души разглеждат сега
        </span>
        <button
          onClick={(e) => { e.preventDefault(); toggleWishlist(product); }}
          className={`absolute top-3 right-3 w-9 h-9 flex items-center justify-center bg-white/90 rounded-full transition-colors ${liked ? "text-gold" : "text-navy"}`}
          data-testid={`featured-wishlist-${product.id}`} aria-label="Любими">
          <Heart size={17} fill={liked ? "#C6A45C" : "none"} />
        </button>
      </Link>

      <div className="p-4 flex flex-col flex-1">
        <div className="flex flex-wrap gap-1.5 mb-2">
          {isMasterpiece && (
            <span className="flex items-center gap-1 text-[10px] uppercase tracking-wider bg-gold text-white px-2 py-0.5"><Sparkles size={10} /> Шедьовър</span>
          )}
          <span className="text-[10px] uppercase tracking-wider border border-gold text-gold px-2 py-0.5">Рядко произведение</span>
        </div>
        <Link to={`/kartina/${product.slug || product.id}`}>
          <h3 className="font-serif text-lg text-navy leading-snug line-clamp-1 group-hover:text-gold transition-colors">{product.title}</h3>
        </Link>
        <p className="text-xs text-charcoal/50 mt-1">{[product.size, product.technique].filter(Boolean).join(" · ")}</p>
        <p className="flex items-center gap-1.5 text-xs text-green-700 mt-1.5">
          <CheckCircle2 size={13} /> {product.in_stock ? "Налично · готово за доставка" : "Изчерпано"}
        </p>
        <div className="flex items-center justify-between mt-3 pt-3 border-t border-stone">
          <span className="font-serif text-xl text-navy" data-testid={`featured-price-${product.id}`}>{formatPrice(product.price)}</span>
        </div>
        <Link to={`/kartina/${product.slug || product.id}`}
              className="block text-center mt-3 btn-gold py-2.5 text-sm rounded-sm"
              data-testid={`featured-details-${product.id}`}>
          Виж детайли
        </Link>
      </div>
    </div>
  );
}
